var app = angular.module("leonardo");

var OnDemandDeleteDialog = function($scope, $rootScope, FormErrorsService, $timeout) {
  $scope.item = $scope.ngDialogData.item;
  $scope.type = $scope.ngDialogData.type;
  $scope.message = $scope.ngDialogData.message;
  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.item.remove().then(function() {
      $timeout(function () {
        $rootScope.$broadcast('on-demand-instruction:updated');
      }, 100);
      $scope.confirm();
    }, function () {
      $scope.closeThisDialog();
    });
  };
};

app.controller('OnDemandDeleteDialog', ['$scope', '$rootScope', 'FormErrorsService', '$timeout', OnDemandDeleteDialog]);
